export const commonFirmsNames = [
  "American Funds",
  "Charles Schwab",
  "Fidelity",
  "JP Morgan Chase",
  "T. Rowe Price",
  "Principal"
];
